import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import storeHelper from '@/store/helper'
import FileDownload from 'js-file-download'
import moment from 'moment'
import axios from 'axios'
import { getUrl, Upload } from './customer-support'

export class DeviceService extends BaseService {
  // loại thiết bị
  static async typeDeviceConfig(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.category.get-all'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getOptionDataType(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.get-by-type'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async dowFileSimExcel(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.sim.export-excel'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'export_list_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async dowFileMCselActivate(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.download-file-order-commerce'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'template_tu_kich_hoat' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async UploadFileMCselActivate(formData, onUploadProgress) {
    const url = getUrl('cnps.device.order.transfer.read-file-commerce')
    const results = await Upload(url, formData, onUploadProgress)
    return results
  }

  static async DownloadErrorMCselActivate(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.download-file-error-commerce'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'template_tu_kich_hoat_that_bai' +
          moment(new Date(new Date())).format('DD/MM/YYYY') +
          '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async ComfirmECommerce(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.create-e-commerce'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async leadAddDeviceSerial(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.add-device-serials'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDetailSim(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.sim.detail'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getHistorySim(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.sim.get-history'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async ComfirmEmployeECommerce(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.create-e-commerce-employee'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async ComfirmEmployeECommerceSim(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.create-e-commerce-employee-tb-with-sim'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // thông tin kho (dành riêng cho ds thiết bị)
  static async infoWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.get-all'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // THIẾT BỊ
  static async listDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async listRequestTicket(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.request-ticket.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailRequestTicket(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.request-ticket.detail'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async listDeviceStatus(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.normal-device.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async listDevicePaser(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.appendix.get-device-in-list-contract'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async confirmRequestTicket(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.request-ticket.confirm'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectConfirmRequestTicket(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.request-ticket.reject-confirm'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async approveRequestTicket(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.request-ticket.approve'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectRequestTicket(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.request-ticket.reject'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async listDeviceByInventory(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.detail.inventory'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async listDeviceAgent(body = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl(
          'cnps.device.order-transfer-agency.get-list-device-in-employee-inventory'
        ),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.detail'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailDeviceStatus(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.normal-device.detail'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.export-excel'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async warrantySuccess(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.confirm.warranty.success'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // static async exportDevice (params) {
  //
  //   try {
  //     const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.device.export-excel'), params, {
  //       responseType: 'blob'
  //     })

  //     if (response.headers['content-type'] === 'application/json') {
  //       alert('Không có dữ liệu để tải xuống')
  //       return
  //     }
  //     FileDownload(response.data, 'Danh_sach_thiet_bi' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
  //     return new ResponseWrapper(response, response.data.data)
  //   } catch (error) {
  //     console.log(error)
  //     const message = error.response.data ? error.response.data.error : error.response.statusText
  //     throw new ErrorWrapper(error, message)
  //   }
  // }

  // DANH MỤC THIẾT BỊ
  static async listCatDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.category.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async listTingboxsim(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.list-link-tingboxsim'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async dowTemplateTingboxsim(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.link.device.download-template-excel'),
        body,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Sim_tingbox' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )

      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async dowTemplateTingbox(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.handover.export-excel'),
        body,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Sim_tingbox' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )

      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async importFileSimTingBox(formData, onUploadProgress) {
    const url = getUrl('cnps.device.import-file-tingbox-sim')
    const results = await Upload(url, formData, onUploadProgress)
    return results
  }

  static async exportSimForDeviceById(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.clear-sim-by-id'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportExampleSimDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.clear-sim.download-file-template'),
        body,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'File_Sim_Example' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )

      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async importSimForDevice(formData, onUploadProgress) {
    const url = getUrl('cnps.device.clear-sim-by-file')
    const results = await Upload(url, formData, onUploadProgress)
    return results
  }
  static async exportErrorSimDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.clear-sim.download-file-error'),
        body,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'File_Sim_Error' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )

      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  //management-sim
  static async listSimCard(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.sim.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportListSimNeedRenewal(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.sim.download-template'),
        body,
        {
          responseType: 'blob',
        }
      )
      FileDownload(response.data, 'Import_Sim.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportListSimRenewed(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.sim.download-template-renew'),
        body,
        {
          responseType: 'blob',
        }
      )
      FileDownload(response.data, 'Import_Sim_Renew.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async ImportFileNeedRenewalSim(formData, onUploadProgress) {
    const url = getUrl('cnps.scon.sim.import-file')
    const results = await Upload(url, formData, onUploadProgress)
    return results
  }

  static async ImportFileRenewedSim(formData, onUploadProgress) {
    const url = getUrl('cnps.scon.sim.import-file-renew')
    const results = await Upload(url, formData, onUploadProgress)
    return results
  }

  static async downloadFileNeedRenewalError(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.sim.download-file-error'),
        body,
        {
          responseType: 'blob',
        }
      )
      FileDownload(response.data, 'File_Sim_Error.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async downloadFileRenewedError(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.sim.download-file-renew-error'),
        body,
        {
          responseType: 'blob',
        }
      )
      FileDownload(response.data, 'File_Sim_Renewed_Error.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getMcHasContract(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.sim.get-list-customers-contracts'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateSimForMc(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.sim.authen-merchant'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async addTingboxsim(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.create-link-tingboxsim'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async addCatDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.category.create'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async editCatDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.category.update'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportCatDevice(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.category.export-excel'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Danh_muc_thiet_bi' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailCatDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.category.detail'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async changeStateCat(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.category.change-state'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // KHO
  static async getListWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.get'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListSearchWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.get-all'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListWarehouseActive(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.get-state'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListWarehouseUserActive(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.get-by-keeper'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async reportLossDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.export.notice-loss'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // NHẬP KHO
  static async getListSupllier(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.supplier.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListImportWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.import.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListReturnRequest(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.return.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportExcelReturnRequest(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.return.export-excel'),
        body,
        { responseType: 'blob' }
      )
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `Danh-sach-yeu-cau-hoan-hang-${Date.now()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailReturnRequest(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.return.detail'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createReturnRequest(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.return.create'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateReturnRequest(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.return.update'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async readFileReturnRequest(formData) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.return.read-file'),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async downloadFileTemplateReturnRequest() {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.return.download-file-template'),
        {},
        { responseType: 'blob' }
      )
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `Mau-phieu-yeu-cau-hoan-hang-${Date.now()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async approveReturnRequest(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.return.approve'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectReturnRequest(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.return.reject'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async cancelReturnRequest(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.return.cancel'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async downloadFileErrorReturnRequest(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.return.download-file-error'),
        body,
        { responseType: 'blob' }
      )
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `Danh-sach-loi-hoan-hang-${Date.now()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getAllDeviceCanReturn(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.get-all-can-return'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailImportWarehouse(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.import.detail'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createImportWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.import.create'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateImportWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.import.update'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async approveImportWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.import.approve'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectImportWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.import.reject'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async cancelImportWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.import.cancel'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportExcelImportWarehouse(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.import.export-excel'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'tExcelImportWarehouse' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async importDeviceExcelImportWarehouse(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.import.read-file'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportDeviceExcelImportWarehouse(params = []) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.import.download-file-error'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Import_Devices_Error' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListTransferAgency(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order-transfer-agency.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListTransferWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListAgency(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.agent.agency.list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListTransferAgent(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.receipt-agency.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailTransferWarehouse(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.detail'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailTransferAgencyNew(receiptId) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.receipt-agency.detail'),
        { receiptId }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailTransferAgency(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order-transfer-agency.detail'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailTransferAgency(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order-transfer-agency.detail'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailHistoryTransferWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.device'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createTransferWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.create'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async createTransferAgencys(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.receipt-agency.create'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateTransferWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.update'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateTransferAgencys(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.receipt-agency.update'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText
      console.log(message)

      throw new ErrorWrapper(error, message)
    }
  }
  static async approveTransferWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.approve'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async approveGeneralTransferWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.purchase-order.create-from-transfer-order'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateCareStatus(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.boxme.update-care-status'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateAgencyInfo(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.receipt-agency.update-by-sale-admin'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateSaleCare(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.boxme.update-sale-care-id'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async cancelReceipt(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.receipt-agency.action'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async changeSTTReceipt(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.receipt-agency.change-stt-invoice-by-accountant'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }
  static async rejectReceipt(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.receipt-agency.action-by-sa'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }
  static async editCodeReceipt(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.receipt-agency.action-by-accountant'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectTransferWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.reject'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async cancelTransferWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.cancel'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async cancelMovingTransferWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.cancel.import'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async approveExportTransferWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.confirm.export'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectImportTransferWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.reject.import'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async approveImportTransferWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.confirm.import'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportTemplateTransferWarehouse(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.download-file-template'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Transfer_Devices_Template' +
          '_' +
          moment(new Date(new Date())).format('DD/MM/YYYY') +
          '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportTemplateTransferAgent(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.download-file-template'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Agent_Devices_Template' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportExcelTransferAgency(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order-transfer-agency.export-excel-device-by-order'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'tExcelTransferWarehouse' +
          '_' +
          moment(new Date(new Date())).format('DD/MM/YYYY') +
          '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportExcelTransferWarehouse(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.export-excel'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'tExcelTransferWarehouse' +
          '_' +
          moment(new Date(new Date())).format('DD/MM/YYYY') +
          '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportExcelTransferAgencyDetail(params, bill) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order-transfer-agency.export-excel-device-by-order'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        bill + '_' + moment(new Date(new Date())).format('DDMMYYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportExcelTransferWarehouseDetail(params, bill) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.export-excel-device-by-order'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        bill + '_' + moment(new Date(new Date())).format('DDMMYYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async importDeviceExcelTransferWarehouse(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.read-file'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async importDeviceExcelTransferAgent(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order-transfer-agency.import-file-device'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportDeviceExcelTransferWarehouse(params = []) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.download-file-error'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Transfer_Devices_Error' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportDeviceExcelTransferAgent(params = []) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.transfer.download-file-error'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Transfer_Devices_Error' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async createWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.create'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }
  static async createWarehouseAgency(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.create-agency'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.edit'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateBankWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.edit-bank-inventory'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateWarehouseEmployee(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.employee.edit'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListSimByEmployee(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.employee'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListDeviceBoxme(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.boxme.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListDeviceWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.device.get'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }
  static async actionWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.action'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }

  static async getDetailWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.get'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListUserByRegion(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.sur.get-list-user-by-region'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async RetrySim(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.retry-scan-appendix-sim'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async downloadFileErrorSim(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.download-error-tingbox-sim'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Data_Error_Sim' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async downloadFileTemplate(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.import.download-file-template'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Import_Devices_Template' +
          '_' +
          moment(new Date(new Date())).format('DD/MM/YYYY') +
          '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportExcel(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.export-excel'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Export_Inventory' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // XUẤT KHO
  static async listExportWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.export.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async detailExportWarehouse(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.export.detail'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportExcelExportWarehouse(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.export.export-excel'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Xuat_kho' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async inTransferTicket(params) {
    try {
      const response = await this.request({ auth: true }).post(
        `${window._env_?.VUE_APP_GEN_PDF ?? process.env.VUE_APP_GEN_PDF}/api/devices/transfer-ticket`,
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      const fileURL = URL.createObjectURL(response.data)
      window.open(fileURL)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async inExportTicket(params) {
    try {
      const response = await this.request({ auth: true }).post(
        `${window._env_?.VUE_APP_GEN_PDF ?? process.env.VUE_APP_GEN_PDF}/api/devices/export-ticket`,
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      const fileURL = URL.createObjectURL(response.data)
      window.open(fileURL)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async inImportTicket(params) {
    try {
      const response = await this.request({ auth: true }).post(
        `${window._env_?.VUE_APP_GEN_PDF ?? process.env.VUE_APP_GEN_PDF}/api/devices/import-ticket`,
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      const fileURL = URL.createObjectURL(response.data)
      window.open(fileURL)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // BÁO CÁO
  static async reportDeviceContract(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.report.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
    }
  }

  static async listReport(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.report.get-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async downloadReport(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.report.download'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'BaoCaoThietBi' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async downloadReportDeviceContract(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.report.download'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'DS_ThietBi_len_HopDong' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // kpi
  static async deviceKpiGetList(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.get-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async orderKpiGetList(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-file-upload.get-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async orderKpiDeital(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-file-upload.detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async deviceKpiDetail(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async orderKpiCreate(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-file-upload.create'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async deviceKpiGetLogs(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.get-kpi-aggregate-logs'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async kpiSynchronizedStatus(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.synchronized-status'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // hủy
  static async deviceKpiCancel(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.cancel'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // update
  static async deviceKpiUpdate(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // gửi duyệt
  static async deviceKpiSendApprove(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.send-approve'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // KT xác nhận
  static async deviceKpiAccountantApprove(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.accountant-approve'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // KT upload status file
  static async deviceKpiAccountantUploadStatusFile(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.accountant-change-status-contract'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // KT từ chối
  static async deviceKpiAccountantReject(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.accountant-reject'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // KT bổ sung
  static async deviceKpiAccountantAdditional(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.accountant-request-additional'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // admin bổ sung
  static async deviceKpiSAAdditional(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.SA-additional'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // GS từ chối
  static async deviceKpiMonitorReject(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.monitor-reject'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // GS duyệt
  static async deviceKpiMonitorApprove(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.monitor-approve'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // Cần giải trình
  static async deviceKpiMonitorRequestExplanation(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.monitor-request-explanation'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // SA giải trình
  static async deviceKpiSAExplanation(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.SA-explanation'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // cập nhật trạng thái nhận file KPI
  static async deviceKpiChangeFileStatus(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.change-file-status'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // check payment
  static async checkDeviceKpiPaymentInfo(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-file-upload.check-kpi-payment-info'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // check sell
  static async checkDeviceKpiSellInfo(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-file-upload.check-kpi-sell-info'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async orderKpiDownloadFileError(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-file-upload.download-file-error'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Upload_Devices_Error' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async deviceKpiReadFile(params) {
    console.log(storeHelper.getUrl('cnps.summary.file.import'))
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.summary.file.import'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async deviceKpiReadFileDemo(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.file.import'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // upload KT
  static async kpiReadFileApproveAcount(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.read-file-approve-account'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // error KT
  static async kpiKTDownloadFileError(errorList = []) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.accountant-approve.download-file-error'),
        errorList,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Upload_Devices_Error' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  // xuat excel
  static async kpiExportExcel(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.export-excel'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Danh_sach_kpi' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async orderKpiDownloadFileTemplate(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-file-upload.download-file-template'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Export_Teampleta' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  //end kpi

  static async getListDevideHandover(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.handover.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async comfirmDeviceHandover(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.appendix.list-handle-handover'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async sendConfirmHandover(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.appendix.send-confirm-handover'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateImageHandoverDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.appendix.update-image-handover-device'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getDeviceInContract(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.appendix.get-device-in-contract'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async customerActionConfirmInPublic(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.appendix.confirm-handover'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListWarranty(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.warranty.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListDeviceActive(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.inventory.get-by-status'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailWarranty(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.warranty.detail'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListError(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.info-error.get-all-by-abbreviation'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async createWarranty(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.warranty.create'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateWarranty(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.warranty.update'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async approveWarranty(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.warranty.approve'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }
  static async sendApproveWarranty(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.warranty.send-approve'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }
  static async receiveWarranty(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.warranty.receive'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }
  static async rejectWarranty(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.warranty.reject'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }
  static async cancelWarranty(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.warranty.cancel'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListErrorType(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.info-error.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async createErrorType(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.info-error.create'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getDetailErrorType(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.info-error.detail'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateErrorType(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.info-error.update'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async changeStatusErrorType(id) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.info-error.change-state'),
        { id }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailDeviceHistory(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.history'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async activeWarranty(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.warranty.re-update'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailDeviceHistory(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.history'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportWarranty(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.warranty.export-excel'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Phieu_bao_hanh' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async deviceKindNomal(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.category.get-all.by.kind'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async downloadFileKpiTemplate(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.template-file-monitor'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        `Template_${params.actionMonitor === 'APPROVE' ? 'duoc_duyet' : params.actionMonitor === 'ADDITIONAL' ? 'can_SA_giai_trinh' : 'tu_choi'}` +
          '_' +
          moment(new Date(new Date())).format('DD/MM/YYYY') +
          '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async monitorApproveKpiReadFile(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.read-file-monitor-approve'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async monitorAdditionalKpiReadFile(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.read-file-monitor-additional'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async monitorRejectKpiReadFile(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.read-file-monitor-reject'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async monitorApproveKpiDownloadFileError(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.monitor-approve.download-file-error'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Upload_KPI_Error' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async monitorAdditionalKpiDownloadFileError(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.monitor-additional.download-file-error'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Upload_KPI_Error' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async monitorRejectKpiDownloadFileError(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.monitor-reject.download-file-error'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Upload_KPI_Error' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async acceptResultApproveRecord(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.monitor-approve'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async acceptResultAdditionalRecord(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.monitor-request-explanation'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async acceptResultRejectRecord(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.monitor-reject'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailDeviceHistoryStatus(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.normal-device.history-for-status'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListQuantityMaterial(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.balance.get-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async checkDateOrderComplete(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.check-date.order-complete'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getQuantityOfDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.get-device-quantity'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async createOrderQuantityMaterial(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.balance.create'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async detailQuantityMaterial(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.balance.detail'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateOrderQuantityMaterial(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.balance.update'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async approveQuantityMaterial(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.balance.approve'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async rejectQuantityMaterial(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.balance.reject'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async cancelQuantityMaterial(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.balance.cancel'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async editDateComplete(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.change-date.order-export-import'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportQuantityMaterial(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.balance.export-excel'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Phieu_dieu_chinh_so_luong' +
          '_' +
          moment(new Date(new Date())).format('DD/MM/YYYY') +
          '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async deviceOrderExportGetDeviceMc(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.export.get-device-mc'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async fetchReportInventory(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.report.filter-device'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportReportInventory(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.report.export-filter-device'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Report_Inventory' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async fetchPolicyDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.contract-policy.get-all'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updatePolicyDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.contract-policy.update'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async createPolicyDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.contract-policy.create'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getDetailPolicyDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.contract-policy.get-by-ids'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async changeStatePolicyDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.contract-policy.change-status'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async fetchSyncDataKpi(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.kpi.kpi-aggregate.synchronized.kpi-device-mc'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async listDeviceByReason(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.get-all-by-reason-and-region'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async createUsageChange(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.usage-change.create'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListUsageChange(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.usage-change.get-list'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getDetailUsageChange(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.usage-change.detail'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async updateUsageChange(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.usage-change.update'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async rejectUsageChange(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.usage-change.import.reject'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async cancelUsageChange(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.usage-change.cancel'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async approveUsageChange(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.usage-change.approve'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportTemplateUsageChange(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.usage-change.download-file-template'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Usage_Change_Template' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async importDeviceExcelUsageChange(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.usage-change.read-file'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async exportDeviceExcelUsageChange(params = []) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.usage-change.download-file-error'),
        params,
        {
          responseType: 'blob',
        }
      )
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống hoặc bạn không có quyền')
        return
      }
      FileDownload(
        response.data,
        'Usage_Change_Error' + '_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListTPVMerchant(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.summary.tpv.sale.detail-mc-by-user'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListTPVMerchantT7(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.summary.tpv.sale.detail-mc-by-user-bk'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListRentalandReturn(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.contract.key.rental-and-return'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListTrackRentAddendum(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.contract.key.track-rent-addendum'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getRentDetail(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.contract.key.detail-rent-addendum'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async requestUpdate(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.contract.key.request-adjusment'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async confirmPolicy(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.contract.key.confirm-rent-appendix'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async changePolicy(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.contract.key.policy-adjustment'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDetailPolicyDevice_V2(params) {
    try {
      const response = await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_CONFIG ?? process.env.VUE_APP_GET_CCRP_CONFIG}/contract-policy/get-by-ids`,
        params,
        {
          headers: {
            Authorization: 'Bearer ' + params.token,
          },
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async policyExchangeAsk(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.warranty.policy-exchange-ask'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async policyExchangeRely(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.order.warranty.policy-exchange-rely'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListOrderForm(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.purchase-order.get-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async AddOrderFormPartner(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.purchase-order.create-order-transfer-by-mnp'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async UpdateOrderFormPartner(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.purchase-order.update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async CreateReceiptAgencys(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.receipt-agency.create'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async DetailGetListDeviceOrder(params = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.purchase-order.get-list-device-in-transfer-order'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async DetailOrderFormPartner(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.purchase-order.detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async DetailOrderFormPartnerByCode(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.purchase-order.detail-by-code'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async ComfirmOrder(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.purchase-order.confirm-by-agent'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async RejectOrder(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.purchase-order.reject-by-mnp'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async CancelOrder(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.purchase-order.cancel'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getListDevicePartner(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.purchase-order.get-list-category-by-partner'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getStoreForDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.css.store.search'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }

  static async ChangeStoreDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.css.device-store.change-store-for-device'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      console.log(message)
      throw new ErrorWrapper(error, message)
    }
  }
  // management lend device
  static async getListLendDevice(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.dfs.lending.list-mc-device'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListLendDeviceV1(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.lending.list-mc-device'),
        body
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async exportLendDeviceV1(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.lending.export'),
        params,
        {
          responseType: 'blob',
        }
      )

      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(
        response.data,
        'Danh_sach_thiet_bi_cho_muon_' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx'
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getDetailLendDeviceV1(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.lending.detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDetailLendDevice(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.dfs.lending.detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async extendDevice(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.lending.action-extend'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async recallDevice(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.lending.action-recall'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async syncTPVLendDevice(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.device.sync-tpv.device-lending-by-lending-id'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDataChartReport(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.dfs.report.tpv-lend-merchant-device.get-data-report'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDataChartReportV2(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.dfs.lending.get-tpv-report'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
